import { AnyAction } from '@reduxjs/toolkit';
import { parentDidNavigate } from '../../actions/ui';
import * as CaseActions from '../../actions/cases.action';
import authSubscriptions from '../../core/authentication-channel/child-window-subscriptions';

const subscriptions: CMx.ChannelSubscription[] = [...authSubscriptions];

const buildSubscriptions = (url: URL) => {
  const id = url.searchParams.get('caseId');
  let caseId = id === null ? Number.NEGATIVE_INFINITY : parseInt(id);

  const caseJsonActions = new Set<string>([
    CaseActions.navigateDetail.fulfilled.type
  ]);

  subscriptions.push({
    match: (message: AnyAction) => {
      return message.payload && caseJsonActions.has(message.type);
    },
    transform: (message: AnyAction) => {
      const sameCase = caseId === message.payload?.case_id;
      return parentDidNavigate(sameCase);
    }
  });
  return subscriptions;
};

export { buildSubscriptions };
